import { getMessages } from '../../../../../../../store/constants';

export const CARD_COMMENT_REACTION__REMOVED = getMessages().getText('activity_item_card__comment_reaction_removed');
export const CARD_COMMENT_REACTION_ADDED = getMessages().getText('activity_item_card__comment_reaction_added');
